import { find, findIndex, isEmpty } from 'lodash';

import * as types from './constants';
import { convertArrayToObject } from '../../utils/arrayConvert';
// import { generateQueryString, removeFromQueryString } from '../../utils/queryString';

export const initialState = {
  listData: {
    dataTable: [],
    loading: false,
    tagsLoading: false,
    tagsUpdateLoading: false,
    count: 0,
    next: null,
    previous: null,
    curr_page: 1,
    errors_api: {},
    queryParsed: false,
    message: null,
    tags: [],
    filters: [
      { key: 'sort', active: false, value: '-gmv_per_period_group' },
      { key: 'gmv_per_period_groups', active: false, value: [] },
      { key: 'gmv_per_click_groups', active: false, value: [] },
      { key: 'links_per_period_groups', active: false, value: [] },
      { key: 'clicks_per_link_groups', active: false, value: [] },
      { key: 'ranks', active: false, value: [] },
      { key: 'is_connected', active: false, value: null },
      { key: 'is_recommended', active: false, value: null },
      { key: 'has_chatted', active: false, value: null },
      { key: 'has_joined_recently', active: false, value: null },
      { key: 'recently_shared', active: false, value: null },
      { key: 'related_domains', active: false, value: [] },
      { key: 'category_ids', active: false, value: [] },
      { key: 'link_category_ids', active: false, value: [] }
    ]
    // filters: [
    //   { key: 'sort', filterTitle: 'Sort By', selected: true, value: sorts.default },
    //   { key: 'match_filters', filterTitle: 'Match Filters', selected: true, value: 'all' },
    //   { key: 'gmv_per_period_quartiles', filterTitle: 'GMV per period', selected: false, value: [] },
    //   { key: 'gmv_per_click_quartiles', filterTitle: 'GMV per click', selected: false, value: [] },
    //   { key: 'links_per_period_quartiles', filterTitle: 'Links per period', selected: false, value: [] },
    //   { key: 'clicks_per_link_quartiles', filterTitle: 'Clicks per link', selected: false, value: [] },
    //   { key: 'tags_options', filterTitle: 'Tags Options', selected: true, value: 'all_selected' },
    //   { key: 'tags', filterTitle: 'Tags', selected: false, value: [] },
    //   { key: 'tags_to_exclude', filterTitle: 'Exclude Tags', selected: false, value: [] }
    // ]
  }
};

const actions = {

  // Get Discover
  [types.GET_DISCOVER_REQUEST]: state => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: true
      }
    };

    return { ...data };
  },

  [types.GET_DISCOVER_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: false,
        ...payload
      }
    };

    return { ...data };
  },

  [types.GET_DISCOVER_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: false,
        errors_api: payload
      }
    };

    return { ...data };
  },

  [types.GET_DISCOVER_RESET]: () => {
    return { ...initialState };
  },

  // Operations
  [types.UPDATE_USER_DISCOVER_USERS]: (state, { payload }) => {
    const newDataTable = state.listData.dataTable.map(el => (el.uuid === payload.uuid && payload.unmasking_status === 'unmasked') ? {
      ...el,
      uuid: payload.uuid,
      user: { ...el.user, uuid: payload.uuid, name: payload.name, id: payload.uuid, avatar_url: payload.avatar_url, avatar_params: payload.avatar_params },
      avatar: { url: payload.avatar_url, params: payload.avatar_params },
      creatorMobile: { name: payload.name, avatar_url: payload.avatar_url, avatar_params: payload.avatar_params },
      status: 'connected',
      operations: { ...el.operations, user: { ...el.operations.user, unmasking_status: 'unmasked'  } }
    } : el);

    const data = {
      ...state,
      listData: {
        ...state.listData,
        dataTable: newDataTable
      }
    };

    return { ...data };
  },

  [types.UPDATE_MULTI_USER_DISCOVER_USERS]: (state, { payload }) => {
    const newDataTable = state.listData.dataTable.map(el => {
      const item = find(payload, x => el.uuid === x.invited.uuid);

      if (item && item.invited.unmasking_status === 'unmasked') {
        return {
          ...el,
          uuid: item.invited.uuid,
          user: { ...el.user, uuid: item.invited.uuid, name: item.invited.name, id: item.invited.uuid, avatar_url: item.invited.avatar_url, avatar_params: item.invited.avatar_params },
          avatar: { ...el.avatar, url: item.invited.avatar_url, params: item.invited.avatar_params },
          creatorMobile: { ...el.creatorMobile, name: item.invited.name, avatar_url: item.invited.avatar_url, avatar_params: item.invited.avatar_params },
          status: 'connected',
          operations: { ...el.operations, user: { ...el.operations.user, unmasking_status: 'unmasked'  } }
        };
      } else return el;
    });

    const data = {
      ...state,
      listData: {
        ...state.listData,
        dataTable: newDataTable
      }
    };

    return { ...data };
  },

  [types.SET_DISCOVER_FILTER]: (state, { payload }) => {
    const index = findIndex(state.listData.filters, x => x.key === payload.key);
    const updatedFilters = [...state.listData.filters];

    if (index !== -1) {
      updatedFilters[index].value = payload.value;
      updatedFilters[index].active = payload.active;
    }

    const data = {
      ...state,
      listData: {
        ...state.listData,
        filters: updatedFilters,
        curr_page: 1
      }
    };

    return { ...data };
  },

  [types.SET_DISCOVER_ALL_FILTERS]: (state, { payload }) => {
    let updatedFilters = [...state.listData.filters];

    payload.forEach(filter => {
      const index = findIndex(updatedFilters, x => x.key === filter.key);
      if (index !== -1) updatedFilters[index] = { ...updatedFilters[index], ...filter };
    });

    const data = {
      ...state,
      listData: {
        ...state.listData,
        filters: updatedFilters,
        curr_page: 1,
        queryParsed: true
      }
    };

    return { ...data };
  },

  [types.CLEAR_DISCOVER_FILTERS]: (state, { payload: { filterToUpdate } }) => {
    if (!isEmpty(filterToUpdate)) {
      const index = findIndex(state.listData.filters, x => x.key === filterToUpdate.key);
      const updatedFilters = [...state.listData.filters];
      if (index !== -1) {
        updatedFilters[index].value = filterToUpdate.value;
        updatedFilters[index].active = filterToUpdate.active;
      }

      const data = {
        ...state,
        listData: {
          ...state.listData,
          filters: updatedFilters,
          curr_page: 1
        }
      };

      // window.history.replaceState({}, '', `${window.location.pathname}${removeFromQueryString(filterToUpdate.key)}`);

      return { ...data };
    } else {
      const data = {
        ...state,
        listData: {
          ...state.listData,
          filters: [
            ...state.listData.filters.filter(x => x.key === 'sort'),
            ...state.listData.filters.filter(x => x.key === 'recently_shared'),
            ...initialState.listData.filters.filter(x => x.key !== 'sort' && x.key !== 'recently_shared')
          ],
          curr_page: 1
        }
      };

      // const findSort = find(data.listData.filters, x => x.key === 'sort');

      // if (findSort.active) {
      //   window.history.replaceState({}, '', `${window.location.pathname}${generateQueryString({ ['sort']: JSON.stringify(findSort.value) })}`);
      // } else {
      //   window.history.replaceState({}, '', `${window.location.pathname}`);
      // }

      return { ...data };
    }
  },

  [types.SET_DISCOVER_COLUMNS]: (state, { payload }) => {

    const data = {
      ...state,
      columnsMemory: {
        ...payload
      }
    };

    return { ...data };
  },

  [types.DISCOVER_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      listData: {
        ...state.listData,
        curr_page: parseInt(payload) || 1
      }
    };

    return { ...data };
  },

  // Get Analytics Tags
  [types.GET_DISCOVER_TAGS_REQUEST]: state => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        tagsLoading: true
      }
    };

    return { ...data };
  },

  [types.GET_DISCOVER_TAGS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        tagsLoading: false,
        tags: payload.results
      }
    };

    return { ...data };
  },

  [types.GET_DISCOVER_TAGS_FAILED]: state => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        tagsLoading: false
      }
    };

    return { ...data };
  },

  // Add Tags Bulk
  [types.ADD_DISCOVER_USERS_TAGS_BULK_REQUEST]: state => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        tagsUpdateLoading: true
      }
    };

    return { ...data };
  },

  [types.ADD_DISCOVER_USERS_TAGS_BULK_DONE]: (state, { payload }) => {
    const updatedData = state.listData.dataTable.map(item => {
      const index = findIndex(payload.user_uuids, x => x === item.uuid);

      if (index !== -1) {
        return { ...item, tags: [...item.tags, ...payload.tags] };
      } else return item;
    });

    const data = {
      ...state,
      listData: {
        ...state.listData,
        dataTable: updatedData,
        tagsUpdateLoading: false
      }
    };

    return { ...data };
  },

  [types.ADD_DISCOVER_USERS_TAGS_BULK_FAILED]: state => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        tagsUpdateLoading: false
      }
    };

    return { ...data };
  },
  
  // Save Columns Width
  [types.SAVE_DISCOVER_COLUMNS]: (state, { payload }) => {

    const data = {
      ...state,
      columnsMemory: convertArrayToObject(state.columnsMemory, payload)
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

